import { absolutePath } from "../absolutePath";

export const entities = {
  index: ({ query, category = "", members_only = false }: any) =>
    absolutePath("masquerading/entities", { query, category, members_only }),
};
